import { Tv2 } from "lucide-react";
import { Link } from "react-router-dom";

export function EmptyState({ title, hint, cta }: { title: string; hint?: string; cta?: { to: string; label: string } }) {
  return (
    <div className="px-6 py-20 text-center">
      <div className="w-14 h-14 rounded-full bg-surface flex items-center justify-center mx-auto mb-4">
        <Tv2 size={22} className="text-accent-gold" />
      </div>
      <h2 className="text-[22px] font-display tracking-[0.5px] text-text-primary mb-2">{title}</h2>
      {hint && <p className="text-[14px] font-ui text-text-secondary max-w-md mx-auto mb-4">{hint}</p>}
      {cta && (
        <Link
          to={cta.to}
          className="inline-block px-5 py-2.5 rounded-pill bg-accent-gold text-canvas text-[13px] font-ui font-medium uppercase tracking-[0.04em] hover:bg-accent-gold-light transition-fast"
        >
          {cta.label}
        </Link>
      )}
    </div>
  );
}
